import React, { Component } from 'react';
import { connect } from 'react-redux';
import SignUpComponent from '../../components/signup/signup';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import jwt from "jsonwebtoken"
import ReactGA from 'react-ga';
import { signUp,getPaymentToken } from './../../../../core/actions/auth';
import {bindActionCreators} from "redux"
import { message } from 'antd';
import {Helmet} from "react-helmet";
class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plan:"free",
      toggleAction: false
    };
  }
  
  componentWillMount() {
    if(window.location.search){
      var params = window.location.search
      var URL = new URLSearchParams(params);
      var token = URL.get("token")
      var data = jwt.decode(token,1864)
      this.props.getPaymentToken(data.paymentTokenID)
    }
  }

  componentDidMount() {
    if (this.props.auth.uid) this.props.history.push('/');
  }
  
  componentWillReceiveProps(nextProps) {

    const { authError, authSuccess ,profile} = nextProps;
    if (authError) message.error(authError);
    if (!nextProps.loading && nextProps.auth.uid && nextProps.authSuccess) {
      // if (authSuccess) message.success(authSuccess);
      localStorage.setItem('role', profile.role);
      localStorage.setItem('uid', profile.uid);

      window.fbq('track', 'CompleteRegistration');
      ReactGA.event({
        category: 'User',
        action: 'Complete Registration',
        label: 'User Interaction'
      });
      // localStorage.setItem('plan', profile.plan);
      this.props.history.push('/');
    }
  }

  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  render() {
    const { toggleAction } = this.state
    var {loading,signUp} = this.props
    return (
      <div  className="signup-page">
         <Helmet>
          <title>Sign up to continue</title>
          <meta name="description" content="Creating a free account will allow you to view all of the free courses orsity has to offer as well as tracking your progress as you learn." />
        </Helmet>
        <TopNav history={this.props.history} toggleAction={toggleAction} toggleModal={this.toggleModal}/>
        <section>
          <div className="table">
            <div className="table-middle-row">
              <SignUpComponent
                plan={this.state.plan}
                history={this.context.router}
                userId={this.props.auth.uid}
                loading={loading}
                signUp={signUp}
                paymentToken={this.props.paymentToken}
                toggleModal={this.toggleModal}
              />
            </div>
          </div>
          <Footer />
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile:state.firebase.profile,
  loading: state.auth.loading,
  authError: state.auth.authError,
  authSuccess: state.auth.authSuccess,
  paymentTokenID: state.auth.paymentTokenID,
  paymentToken: state.auth.paymentToken
});


const mapDispatchToProps = dispatch => bindActionCreators({
  signUp,
  getPaymentToken
},dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp);
